import React from 'react';

export interface CalendarioIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CalendarioIcon: React.FC<CalendarioIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16.333 2v4m-8-4v4m-5 4h18m-16-6h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2"/>
    </svg>
  );
};

export default CalendarioIcon;
